const SYMBOLS = "H He Li Be B C N O F Ne Na Mg Al Si P S Cl Ar K Ca Sc Ti V Cr Mn Fe Co Ni Cu Zn Ga Ge As Se Br Kr Rb Sr Y Zr Nb Mo Tc Ru Rh Pd Ag Cd In Sn Sb Te I Xe Cs Ba La Ce Pr Nd Pm Sm Eu Gd Tb Dy Ho Er Tm Yb Lu Hf Ta W Re Os Ir Pt Au Hg Tl Pb Bi Po At Rn Fr Ra Ac Th Pa U Np Pu Am Cm Bk Cf Es Fm Md No Lr Rf Db Sg Bh Hs Mt Ds Rg Cn Nh Fl Mc Lv Ts Og".split(" ");

const NAMES = "Hidrojen,Helyum,Lityum,Berilyum,Bor,Karbon,Azot,Oksijen,Flor,Neon,Sodyum,Magnezyum,Alüminyum,Silisyum,Fosfor,Kükürt,Klor,Argon,Potasyum,Kalsiyum,Skandiyum,Titanyum,Vanadyum,Krom,Mangan,Demir,Kobalt,Nikel,Bakır,Çinko,Galyum,Germanyum,Arsenik,Selenyum,Brom,Kripton,Rubidyum,Stronsiyum,İtriyum,Zirkonyum,Niyobyum,Molibden,Teknesyum,Rutenyum,Rodyum,Paladyum,Gümüş,Kadmiyum,İndiyum,Kalay,Antimon,Tellür,İyot,Ksenon,Sezyum,Baryum,Lantan,Seryum,Praseodim,Neodim,Prometyum,Samaryum,Evropiyum,Gadolinyum,Terbiyum,Disprosyum,Holmiyum,Erbiyum,Tulyum,İterbiyum,Lutesyum,Hafniyum,Tantal,Tungsten,Renyum,Osmiyum,İridyum,Platin,Altın,Cıva,Talyum,Kurşun,Bizmut,Polonyum,Astatin,Radon,Fransiyum,Radyum,Aktinyum,Toryum,Protaktinyum,Uranyum,Neptünyum,Plütonyum,Amerikyum,Küriyum,Berkelyum,Kaliforniyum,Aynştaynyum,Fermiyum,Mendelevyum,Nobelyum,Lavrensiyum,Rutherfordiyum,Dubniyum,Seaborgiyum,Bohriyum,Hassiyum,Meitneriyum,Darmstadtiyum,Röntgenyum,Kopernikyum,Nihonyum,Flerovyum,Moskovyum,Livermoryum,Tennesin,Oganesson".split(",");

const NONMETALS = new Set([1, 6, 7, 8, 15, 16, 34]);
const METALLOIDS = new Set([5, 14, 32, 33, 51, 52]);

function position(z) {
  if (z === 1) return [1, 1];
  if (z === 2) return [1, 18];
  const starts = [[3, 2], [11, 3], [19, 4], [37, 5], [55, 6], [87, 7]];
  if ((z >= 58 && z <= 71) || (z >= 90 && z <= 103)) {
    const base = z <= 71 ? 58 : 90;
    return [z <= 71 ? 9 : 10, 4 + z - base];
  }
  const [start, period] = [...starts].reverse().find(([s]) => z >= s);
  const off = z - start;
  if (period <= 3) return [period, off < 2 ? off + 1 : off + 11];
  if (period <= 5) return [period, off + 1];
  if (off < 3) return [period, off + 1];
  return [period, off - 14 + 1];
}

function category(z, col) {
  if (col === 18) return "noble";
  if (col === 17 && z !== 117) return "halogen";
  if (NONMETALS.has(z)) return "nonmetal";
  if (METALLOIDS.has(z)) return "metalloid";
  if (col === 1) return "alkali";
  if (col === 2) return "alkaline";
  return "metal";
}

export const ELEMENTS = SYMBOLS.map((symbol, i) => {
  const z = i + 1;
  const [row, col] = position(z);
  return { z, symbol, name: NAMES[i], row, col, category: category(z, (z >= 58 && z <= 71) || (z >= 90 && z <= 103) ? 3 : col) };
});

export const CATEGORY_STYLE = {
  noble: "bg-blue-950 border-blue-700 text-blue-200",
  halogen: "bg-emerald-950 border-emerald-700 text-emerald-200",
  nonmetal: "bg-lime-950 border-lime-700 text-lime-200",
  metalloid: "bg-teal-950 border-teal-700 text-teal-200",
  alkali: "bg-amber-950 border-amber-700 text-amber-200",
  alkaline: "bg-orange-950 border-orange-700 text-orange-200",
  metal: "bg-slate-800 border-slate-600 text-slate-100",
};
